import React from 'react';
import { services } from '../../data/site';
export function Services() {
  return <section id="opgaver" className="scroll-mt-24" data-id="element-431" data-mp="8ldjwahcghz2">
      <div className="mx-auto max-w-content px-5 py-16 md:py-24 lg:px-8" data-id="element-432" data-mp="8m6mr0d6mnbx">
        <div className="grid gap-8 lg:grid-cols-[0.85fr_1.15fr] lg:gap-16" data-id="element-433" data-mp="djotql7n2sha">
          <div data-id="element-434" data-mp="ibzvltlxwoch">
            <h2 className="font-display text-[clamp(2rem,5.5vw,3.5rem)] font-bold leading-[1.05] tracking-tight text-ink" data-id="element-435" data-mp="ici01dira8vh">
              Mangler du en ekstra hånd?
            </h2>
            <p className="mt-5 max-w-md text-[17px] leading-relaxed text-ink-soft" data-id="element-436" data-mp="s94ixwriupuv">
              Har du noget, der skal monteres, repareres eller vedligeholdes? Så er her de opgaver,
              jeg oftest hjælper med — både hjemme hos private og ude i virksomheder.
            </p>
          </div>

          {/* Enkle tekstblokke med tynde linjer i stedet for tre ens kort. */}
          <ul className="divide-y divide-line border-t border-line" data-id="element-437" data-mp="331p9o4etk644">
            {services.map(service => <li key={service.title} className="py-7 first:pt-0 md:py-8" data-id="element-438" data-mp="1oqryaacw6rvf">
                <div className="md:grid md:grid-cols-[13rem_1fr] md:gap-8" data-id="element-439" data-mp="1osux9jw0vvca">
                  <h3 className="font-display text-2xl font-bold tracking-tight text-ink" data-id="element-440" data-mp="1jz0fwn3w3sgd">
                    {service.title}
                  </h3>
                  <div className="mt-2 md:mt-0" data-id="element-441" data-mp="1b056z39go49d">
                    <p className="text-[17px] leading-relaxed text-ink-soft" data-id="element-442" data-mp="1b1gar32wpc0h">
                      {service.description}
                    </p>
                    {service.examples && <p className="mt-1.5 text-[15px] leading-relaxed text-ink-muted" data-id="element-443" data-mp="23ospir2tsfj8">
                        {service.examples}
                      </p>}
                  </div>
                </div>
              </li>)}
          </ul>
        </div>

        {/* Lille fremhævet note — ikke et kort. */}
        <p className="mt-10 max-w-2xl border-l-2 border-accent pl-5 text-[17px] leading-relaxed text-ink-soft" data-id="element-444" data-mp="iaxzvfvxy6ci">
          Er du i tvivl om, om jeg kan hjælpe?{' '}
          <a href="#kontakt" className="font-medium text-accent underline decoration-accent/30 underline-offset-4 transition-colors duration-200 ease-smooth hover:text-accent-deep" data-id="element-445" data-mp="jswmfy2hawed">
            Så spørg endelig
          </a>{' '}
          – du får et ærligt svar, også hvis opgaven ikke er noget for mig.
        </p>
      </div>
    </section>;
}